export const mrpEs = {
  title: 'Planificación de necesidades de material',
  subtitle:
    'Necesidades, entradas y propuestas no vinculantes por fecha con una instantánea reproducible.',
  help: { open: 'Abrir la ayuda de planificación de materiales' },
  tabs: {
    planning: 'Planificación',
    history: 'Historial de ejecuciones',
    policies: 'Parámetros de planificación',
  },
  run: {
    title: 'Crear ejecución MRP',
    description:
      'Elija fecha, horizonte y, opcionalmente, artículos. El MRP nunca crea órdenes automáticamente.',
  },
  fields: {
    asOf: 'Fecha de planificación',
    horizon: 'Fin del horizonte',
    productScope: 'Ámbito de artículos',
    strategy: 'Estrategia de suministro',
    safetyStock: 'Stock de seguridad',
    procurementLead: 'Plazo de compra (días)',
    productionLead: 'Plazo de producción (días)',
    productionMinimum: 'Cantidad mínima de producción',
    productionLot: 'Tamaño de lote de producción',
    note: 'Motivo / nota',
  },
  allProducts: 'Todos los artículos con stock',
  actions: {
    run: 'Ejecutar MRP',
    'convert-purchase': 'Crear borrador de compra',
    'convert-production': 'Crear borrador de producción',
    dismiss: 'Descartar propuesta',
  },
  messages: {
    invalidInput: 'Revise los datos de planificación.',
    runCreated: 'Se creó la instantánea MRP inmutable.',
    policySaved: 'Parámetros guardados.',
    'convert-purchase': 'Se creó explícitamente el borrador de compra.',
    'convert-production': 'Se creó explícitamente el borrador de producción.',
    dismiss: 'Propuesta descartada con motivo.',
  },
  stats: {
    products: 'Artículos',
    shortages: 'Faltantes',
    purchase: 'Propuestas de compra',
    production: 'Propuestas de producción',
    manual: 'Revisión manual',
    warnings: 'Avisos',
  },
  columns: {
    product: 'Artículo',
    gross: 'Necesidad bruta',
    available: 'Stock disponible',
    reserved: 'Reservado',
    receipts: 'Entradas previstas',
    net: 'Necesidad neta',
    due: 'Fecha de necesidad',
    action: 'Propuesta de acción',
    date: 'Fecha',
    event: 'Evento',
    quantity: 'Cantidad',
    formula: 'Cálculo',
    run: 'Ejecución',
    created: 'Creada',
  },
  empty: {
    noRunTitle: 'No hay resultado seleccionado',
    noRun: 'Cree una ejecución o seleccione un resultado inmutable del historial.',
  },
  snapshot: 'Hash de origen {{sourceHash}} · hash de resultado {{resultHash}}',
  details: {
    timeline: 'Trazabilidad del cálculo',
    timelineDescription:
      'En la misma fecha las entradas se aplican antes que las necesidades; cada entrada propuesta restablece el nivel objetivo.',
    sources: 'Fuentes de demanda y suministro',
    sourcesDescription:
      'Cada cantidad remite al documento, orden de producción o instantánea de stock utilizada.',
  },
  events: {
    OPENING: 'Stock inicial',
    DEMAND: 'Necesidad',
    SUPPLY: 'Entrada',
    PLANNED_RECEIPT: 'Entrada propuesta',
  },
  sourceTypes: {
    SALES_ORDER: 'Pedido de cliente',
    PRODUCTION_MATERIAL: 'Material de producción planificado',
    PLANNED_PRODUCTION_EXPLOSION: 'Necesidad desglosada de receta',
    STOCK: 'Instantánea de stock elegible',
    PURCHASE_ORDER: 'Pedido de compra abierto',
    PRODUCTION_ORDER: 'Entrada de producción planificada',
  },
  suggestion: { none: 'Sin faltante' },
  statuses: { OPEN: 'Abierta', CONVERTED: 'Convertida', DISMISSED: 'Descartada' },
  strategies: {
    AUTO: 'Regla automática',
    BUY: 'Comprar',
    MAKE: 'Producir',
    BUY_OR_MAKE: 'Comprar o producir',
    NONE: 'Solo revisión manual',
  },
  policy: {
    title: 'Parámetros por artículo',
    description:
      'Los umbrales permanecen en el maestro; aquí se añaden estrategia, plazos y tamaños de lote.',
    dialogTitle: 'Editar parámetros',
    dialogDescription: 'El control de versión evita sobrescrituras simultáneas.',
  },
  decision: {
    'convert-purchase': {
      title: '¿Crear borrador de compra?',
      description:
        'Esta acción explícita crea un único borrador desde la propuesta congelada, sin enviarlo ni confirmarlo.',
      confirm: 'Confirmo la creación del borrador de compra.',
    },
    'convert-production': {
      title: '¿Crear borrador de producción?',
      description:
        'Esta acción explícita utiliza la receta y ruta aprobadas guardadas en la propuesta.',
      confirm: 'Confirmo la creación del borrador de producción.',
    },
    dismiss: {
      title: '¿Descartar la propuesta?',
      description:
        'El faltante seguirá visible en la ejecución inmutable y el motivo quedará auditado.',
      confirm: 'Confirmo el descarte de esta propuesta.',
    },
  },
  warningTitle: 'Aviso de planificación',
  warnings: {
    MRP_BATCH_STOCK_RECONCILIATION: 'El total de lotes elegibles difiere del stock del artículo.',
    MRP_BATCH_SHELF_LIFE_MISSING:
      'Se excluyó al menos un lote sin datos de vida útil obligatorios.',
    MRP_INCOMPATIBLE_UNIT: 'Se excluyó una cantidad con unidad incompatible.',
    MRP_SUPPLIER_MISSING: 'No hay una asignación activa de proveedor aprobada.',
    MRP_APPROVED_RECIPE_OR_ROUTING_MISSING: 'No hay receta y ruta aprobadas compatibles.',
    MRP_PROCUREMENT_DISABLED: 'El suministro automático está desactivado.',
    MRP_RELEASE_DATE_OVERDUE:
      'La fecha calculada de lanzamiento es anterior a la fecha de planificación; requiere revisión inmediata.',
  },
} as const;
